import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../../types';

export const eggStaticData = {
  menuTitle: MenuTitle.Engagement
};
export const Route = createFileRoute('/_private-routes/engagement/')({
  staticData: eggStaticData
});
